import React, {Fragment, useContext} from 'react';
import ConfettiAnimation from "../Confetti";
import withAuth from "../../services/withAuth";
import Nav from "../Nav";
import AutoProgressBar from "../ProgressBar";
import Congrats from "../CongratsAnimation";
import {TourContext} from "../../contexts/TourContext";


const AssessmentComplete = ({...props}) => {
    const {state, dispatch} = useContext(TourContext);

    const progressComplete = (result) => {
        if (result) {
            props.history.push('/progress/')
        }
    }


    const openTour = () => {
        if (!state.isOpen) {
            dispatch({
                type: 'OPEN',
            });
        }

    };

    openTour();

    return (
        <Fragment>
            <Nav fromAssessment={true} />
            <ConfettiAnimation/>
            <Congrats/>
            <AutoProgressBar progress={progressComplete.bind(this)}/>
        </Fragment>
    )


}

export default withAuth(AssessmentComplete)